module.exports = __webpack_public_path__ + "static/media/csr_4_good_leader_good_teacher.ff0c8fd5.jpg";